module.exports = __webpack_public_path__ + "img/app.c896d2b8.png";